import { useQuery } from '@tanstack/react-query';
import { SharedService, type SharedBranchQueryParams } from '@repo/api-sdk';

export const sharedBranchKeys = {
  all: ['shared-branches'] as const,
  lists: () => [...sharedBranchKeys.all, 'list'] as const,
  list: (filters?: SharedBranchQueryParams) => [...sharedBranchKeys.lists(), filters] as const,
};

export function useSharedBranches(params?: SharedBranchQueryParams) {
  return useQuery({
    queryKey: sharedBranchKeys.list(params),
    queryFn: async () => {
      const res = await SharedService.getBranches(params);
      return res.data;
    },
  });
}
